import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  formControl: {
    margin: '0px !important',
  },
  input: {
    background: 'var(--color-white) 0% 0% no-repeat padding-box',
    borderRadius: '5px',
    marginBottom: '0px !important',
  },
  helperText: {
    color: '#d70707 !important',
    fontSize: '14px !important',
    margin: '0px !important',
    width: '100% !important',
    height: '40px !important',
    boxSizing: 'border-box !important',
    textAlign: 'start !important',
  },
  containerInput: {
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'row',
    alignItems: 'center',
    height: '50px',
  },
}));

export default useStyles;
